import { Component, OnInit } from '@angular/core';
import { EmailVerificationService } from '../../api/services/email-verification-service';
import { EmailVerificationEmailType } from '../../enums/email-verification-email-type';
import { ToastService } from '../../services/toast.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-email-verification-setup',
  templateUrl: './email-verification-setup.component.html',
  standalone: false,
})
export class EmailVerificationSetupComponent implements OnInit {
  emailVerificationCode: string = '';
  resendButtonDisabled = false;

  constructor(
    private emailVerificationService: EmailVerificationService,
    private toastService: ToastService,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.sendVerificationEmail();
  }

  sendVerificationEmail(disableResend: boolean = false) {
    if (disableResend) {
      // Disable resend button for 30 seconds to prevent abuse
      this.resendButtonDisabled = true;
      setTimeout(() => {
        this.resendButtonDisabled = false;
      }, 30000);
    }

    // Send verification email
    const userGuid = window.history.state.userGuid!;
    this.emailVerificationService
      .sendVerificationEmail({
        body: {
          userGuid,
          emailType: EmailVerificationEmailType.Code,
        },
      })
      .subscribe();
  }

  continue() {
    // Verify code, and proceed to home if successful
    const userGuid = window.history.state.userGuid!;
    this.emailVerificationService
      .validateEmailVerificationToken({
        body: { userGuid, token: this.emailVerificationCode },
      })
      .subscribe({
        next: () => {
          this.toastService.success('Email verified successfully');
          void this.router.navigateByUrl('admin/home');
        },
        error: () => {
          this.toastService.error('Could not verify your email address');
        },
      });
  }
}
